import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_CASHFREE_FAILED,
  GET_CASHFREE_REQUESTED,
  GET_CASHFREE_SUCCESS,
  GET_CASHFREE_VERIFY_FAILED,
  GET_CASHFREE_VERIFY_REQUESTED,
  GET_CASHFREE_VERIFY_SUCCESS
} from "resources/actionTypes";
import { cashfreeApi, cashfreeResponseApi } from "services/CashFreeService";

function* fetchCashFree(action) {
  const payload = action.payload || {};
  const userCashFree = yield call(cashfreeApi, payload.getCashfreeDetail);
  if (userCashFree?.success) {
    yield put({ type: GET_CASHFREE_SUCCESS, userCashFree: userCashFree });
    toast.success(userCashFree?.message)
    localStorage.removeItem('trip');
  }
  else{
    yield put({type: GET_CASHFREE_FAILED, message: userCashFree.message});
      toast.error(userCashFree?.message || "Cashfree Payment failed");
  }
}
export function* cashFreeSaga(){
  yield takeEvery(GET_CASHFREE_REQUESTED, fetchCashFree);
}

function* fetchCashfreeResponse(action) {
  const payload = action.payload || {};
  const userCashfreeResponse = yield call(cashfreeResponseApi, payload.getCashfreeResponses);
  if (userCashfreeResponse?.success) {
    yield put({ type: GET_CASHFREE_VERIFY_SUCCESS, userCashfreeResponse: userCashfreeResponse });
    toast.success(userCashfreeResponse?.message)
  }
  else{
    yield put({type: GET_CASHFREE_VERIFY_FAILED, message: userCashfreeResponse.message});
      toast.error(userCashfreeResponse.message || "Payment failed");
  }
}
export function* cashfreeResponseSaga(){
  yield takeEvery(GET_CASHFREE_VERIFY_REQUESTED, fetchCashfreeResponse);
}
